import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useImpersonation } from "@/hooks/useImpersonation";

export const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedUserEmail, stopImpersonation } = useImpersonation();

  if (!isImpersonating) return null;

  return (
    <Alert className="rounded-none border-x-0 border-t-0 bg-warning/10 border-warning">
      <div className="container flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 text-warning" />
          <AlertDescription className="text-sm font-medium">
            Mode Impersonation actif - Connecté en tant que{" "}
            <span className="font-bold">{impersonatedUserEmail}</span>
          </AlertDescription>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={stopImpersonation}
          className="gap-2"
        >
          <X className="h-4 w-4" />
          Revenir au compte admin
        </Button>
      </div>
    </Alert>
  );
};
